import React from "react";
import { Link } from 'react-router-dom';
import '../style/Profile.css';


export default function Profil() {
    return (
        <>
            <section className="section-10">
                <img className="primg" src={require("../img/10.png")} alt="Error" />
                <div className="profile">
                    <div className="box-10_l">
                        <div className="pr">
                            <img className="pr-img" src={require("../img/10.png")} alt="Error" />
                            <p className="ms-1"><b className="fw-bold">Jaloliddin Esonboyev</b> <br />
                                ichbinabdulvoris@gmail.com</p>
                        </div>
                    </div>
                    <div className="box-10_r">
                        <Link className="btn" to="/setting">Setting</Link>
                    </div>
                </div>
                <div className="sec-10">
                    <div className="box-10">
                        <div className="boxbox-10_l">
                        <img className="" id="pr-1" src={require("../img/pr-1.png")} alt="Error" />
                        <img className="" id="pr-2" src={require("../img/pr-2.png")} alt="Error" />
                        <img className="" id="pr-3" src={require("../img/pr-3.png")} alt="Error" />
                        </div>
                        <div className="boxbox-10_r">
                            <div className="box10">
                                <div className="boxbox10_l">
                                    <h3>Animating</h3>
                                    <p className="mt-2 ">Budget: <b>$70 000</b></p>
                                    <p className="mt-2 ">View your order</p>
                                    <Link className="btn-10" to="/register">Go to chat</Link>
                                </div>
                                <div className="boxbox10_r">
                                    <div className="box-pr">
                                        <p className="pt-1">Process:</p>
                                        <div className="box-line">
                                            <div></div>
                                        </div>
                                        <p className="pt-2">23 hours left</p>
                                    </div>
                                    <div className="box-pr">
                                        <p className="pt-1">Deadline:12/10/2021 </p>
                                        <div className="box-line">
                                            <div className="bg-success"></div>
                                        </div>
                                        <p className="pt-2">Remained: 20 hourst</p>
                                    </div>
                                    <p >Edit</p>
                                    <p className=" text-danger ">Cancel the order</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-10 mt-5">
                        <div className="boxbox-10_l">
                        <img className="" id="pr-1" src={require("../img/pr-1.png")} alt="Error" />
                        <img className="" id="pr-2" src={require("../img/pr-2.png")} alt="Error" />
                        <img className="" id="pr-3" src={require("../img/pr-3.png")} alt="Error" />
                        </div>
                        <div className="boxbox-10_r">
                            <div className="box10">
                                <div className="boxbox10_l">
                                    <h3>Animating</h3>
                                    <p className="mt-2">Budget: <b>$70 000</b></p>
                                    <p className="mt-2 ">View your order</p>
                                    <Link className="btn-10" to="/register">Go to chat</Link>
                                </div>
                                <div className="boxbox10_r">
                                    <div className="box-pr">
                                        <p className="pt-1">Process:</p>
                                        <div className="box-line">
                                            <div></div>
                                        </div>
                                        <p className="pt-2">23 hours left</p>
                                    </div>
                                    <div className="box-pr">
                                        <p className="pt-1">Deadline:12/10/2021 </p>
                                        <div className="box-line">
                                            <div className="bg-success"></div>
                                        </div>
                                        <p className="pt-2">Remained: 20 hourst</p>
                                    </div>
                                    <p >Edit</p>
                                    <p className=" text-danger ">Cancel the order</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-10 mt-5">
                        <div className="boxbox-10_l">
                        <img className="" id="pr-1" src={require("../img/pr-1.png")} alt="Error" />
                        <img className="" id="pr-2" src={require("../img/pr-2.png")} alt="Error" />
                        <img className="" id="pr-3" src={require("../img/pr-3.png")} alt="Error" />
                        </div>
                        <div className="boxbox-10_r">
                            <div className="box10">
                                <div className="boxbox10_l">
                                    <h3>Animating</h3>
                                    <p className="mt-2">Budget: <b>$70 000</b></p>
                                    <p className="mt-2 ">View your order</p>
                                    <Link className="btn-10" to="/register">Go to chat</Link>
                                </div>
                                <div className="boxbox10_r">
                                    <div className="box-pr">
                                        <p className="pt-1">Process:</p>
                                        <div className="box-line">
                                            <div></div>
                                        </div>
                                        <p className="pt-2">23 hours left</p>
                                    </div>
                                    <div className="box-pr">
                                        <p className="pt-1">Deadline:12/10/2021 </p>
                                        <div className="box-line">
                                            <div className="bg-success"></div>
                                        </div>
                                        <p className="pt-2">Remained: 20 hourst</p>
                                    </div>
                                    <p >Edit</p>
                                    <p className=" text-danger ">Cancel the order</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer >
                <div className="foot profil-footer ">
                    <h1 className="mt-5 fw-bold  pt-5">Biz bilan hamkor bo’ling</h1>
                    <p className="text-secondary lead">Biz sifatli va ajoyib modellarni sizga taqdim qilamiz</p>
                    <div className="l">
                        <Link className="but mt-5" to="/order">Order A Project</Link>
                    </div>
                </div>
                <div className="foot-  d-flex justify-content-between">
                    <img src={require("../dizipro.png")} alt="Error" />
                    <div className="nav-menu">
                        <Link className="nav-item text-light  " to="/">Home</Link>
                        <Link className="nav-item text-light  " to="/portfolio">Portfolio</Link>
                        <Link className="nav-item text-light  " to="/order">Order A Project</Link>
                        <Link className="nav-item text-light  " to="/paid">Paid Courses</Link>
                        <Link className="nav-item text-light  " to="/profil">Profil</Link>
                    </div>
                    <div className="i">
                        <i class="fa-brands fa-instagram"></i>
                        <i class="fa-brands fa-telegram"></i>
                        <i class="fa-brands fa-facebook"></i>
                    </div>
                </div>
            </footer>
            </section>
            
        </>
    )
}